export default __webpack_public_path__ + "static/media/Patients.8a92fb98.svg";